module.exports = __webpack_public_path__ + "img/look10.6c4e9e09.png";